// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"AdminEditCallInfoForm_wrapper__3uvMe","buttons":"AdminEditCallInfoForm_buttons__14nal"};